import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { pageKey, validSelected, autoComplete, pushToArray, getHour, getMinute, toHour, hourToNumber } from 'src/app/services/mapping.service';
import { statusObj, DAYS } from 'src/app/dummy/status';
import { Observable } from 'rxjs';
import { IBuilding } from 'src/app/interfaces/country';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-building',
  templateUrl: './add-building.component.html',
  styleUrls: ['./add-building.component.scss']
})
export class AddBuildingComponent implements OnInit {
  @ViewChild("focus", { static: false }) inputRef: ElementRef;

  form: FormGroup;
  campus: AbstractControl;
  name: AbstractControl;
  description: AbstractControl;

  filteredStates: Observable<any[]>;
  constructor(
    public dialogRef: MatDialogRef<AddBuildingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: List,
    public ds: DataService,
    public auth: AuthStore,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      campus: [null, Validators.compose([Validators.required, validSelected.bind(this)])],
      name: [null, Validators.required],
      description: [null],
    });
    this.campus = this.form.controls['campus'];
    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];

    const shifts = await this.ds.campusRef().get().toPromise();
    this.filteredStates = autoComplete(this.campus, pushToArray(shifts), 'name');
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o2) return o1.key === o2.key;
  }

  create(f: any, isNew: boolean) {
    if (this.form.valid) {
      this.form.disable()
      const { campus, name, description } = f;
      const item: IBuilding = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        name: name,
        description: description,
        status: statusObj.active,
        campusRef: this.ds.campusRef().doc(`${campus.key}`).ref,
        campusKey:campus.key,
      }
      this.store.save(this.ds.buildingRef(), item, (success, res) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Building has been created.', 'done', { duration: 3000 });
          this.form.reset();
          this.form.enable();
          this.inputRef.nativeElement.focus();
        } else {
          alert(res);
        }
      })
    }

  }

}
